export const HOME = '/';
export const SUCCESS = '/success';
